import { invokeActivityBasedFormFlowAsync } from "./activity-based-form-flows/index.js";
import { invokeCodedFormFlowAsync } from "./coded-form-flows/index.js";
import { getFormFlowDefinitionLoader } from "./form-flow-engine-initializer.js";
import { isCodedFormFlowDefinition } from "./form-flow-engine-types.js";
import { validateVariables } from "./form-flow-variable-validator.js";
/**
 * Invoke form flow
 * @param formFlowId Form flow id
 * @param input Form flow input
 * @returns Form flow output
 */
export async function invokeFormFlowAsync(formFlowId, input, options) {
    const definitionLoader = getFormFlowDefinitionLoader();
    const definition = await definitionLoader.load(formFlowId, options);
    const inputParameters = Array.isArray(input) ? buildFormFlowInput(definition, input) : input;
    validateVariables("Parameters", definition.Parameters, inputParameters);
    let output;
    if (isCodedFormFlowDefinition(definition)) {
        output = await invokeCodedFormFlowAsync(definition, inputParameters);
    }
    else {
        output = await invokeActivityBasedFormFlowAsync(definition, inputParameters, options);
    }
    validateVariables("OutParameters", definition.OutParameters, output);
    return output;
}
function buildFormFlowInput(definition, inputValues) {
    var _a;
    const result = (_a = definition.Parameters) === null || _a === void 0 ? void 0 : _a.reduce((output, param, index) => {
        output[param.Name] = inputValues === null || inputValues === void 0 ? void 0 : inputValues[index];
        return output;
    }, {});
    return result;
}
